import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

export default function Meta({ isHomepage }) {
  const metaTitleCopy = isHomepage
    ? 'ChowNow | Discover and Order Online from Restaurants Near You | Food Takeout and Delivery'
    : 'Order Food Delivery Or Takeout With No Hidden Fees | ChowNow';
  const metaDescCopy = isHomepage
    ? 'Order food online with no hidden fees. Unlike other takeout and delivery apps, ChowNow supports local restaurants by being 100% commission-free. It’s good for diners and good for restaurants.'
    : 'Find local restaurants near you with low cost delivery, promotions or curbside pickup. Place your order now or order ahead on the only online food ordering app that’s fair for diners and restaurants.';

  return (
    <Head>
      <title>{metaTitleCopy}</title>

      <meta property="og:title" content={metaTitleCopy} key="ogtitle" />
      <meta name="description" content={metaDescCopy} key="title" />
      <meta name="google-site-verification" content="SV5gdD-Hbvyoisn5I4K58P0AkS6KRA9YUapKG97-Orw" />
      <meta
        property="og:image"
        key="image"
        content="https://getchownow.wpenginepowered.com/wp-content/uploads/resource-three.jpg"
      />
    </Head>
  );
}

Meta.propTypes = {
  isHomepage: PropTypes.bool,
};

Meta.defaultProps = {
  isHomepage: false,
};
